/**
 * Service layer — Board Meetings (agendas + minutes, corporate governance).
 *
 * Owns the board_meetings table (Supabase) behind the Clerk-authed /api/board-meetings endpoint.
 * Components never call the API directly — they go through here. See docs/BOARD.md.
 */

async function token() {
  for (let i = 0; i < 25; i++) {
    if (typeof window !== 'undefined' && typeof window.__clerkGetToken === 'function') {
      try { const t = await window.__clerkGetToken(); if (t) return t } catch { /* retry */ }
    }
    await new Promise(r => setTimeout(r, 150))
  }
  return null
}

async function post(payload) {
  const headers = { 'Content-Type': 'application/json' }
  const t = await token(); if (t) headers['Authorization'] = 'Bearer ' + t
  const res = await fetch('/api/board-meetings', { method: 'POST', headers, body: JSON.stringify(payload) })
  const data = await res.json().catch(() => ({ error: 'Bad response from /api/board-meetings' }))
  if (!res.ok || data.error) throw new Error(data.error || ('Request failed (' + res.status + ')'))
  return data
}

export async function listBoardMeetings() {
  return (await post({ action: 'list' })).meetings || []
}

export async function createBoardMeeting(fields) {
  return (await post({ action: 'create', ...fields })).meeting
}

export async function updateBoardMeeting(id, fields) {
  return (await post({ action: 'update', id, ...fields })).meeting
}

export async function deleteBoardMeeting(id) {
  return (await post({ action: 'delete', id })).ok
}

export async function finalizeBoardMeeting(id) {
  return await post({ action: 'finalize', id })
}
